import React from 'react';

const CustomTextInput = ({ value, label, isRequired, type,onChange, onBlur, textLimit, error, otherClass, helperText, ...props }) => {

  const handleChange = (event) => {
    if (event.target.value.length <= textLimit) {
      onChange(event);
    }
  };

  return (
    <div className="mb-4 m-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {isRequired && <span className="text-red-500">*</span>}
      </label>
      <input
        type={type}
        value={value} 
        onChange={handleChange}
        onBlur={onBlur}
        {...props}
        className={`mt-1 block w-full border border-black shadow-sm  ${
          error ? '!border-red-500' : ''
        } ${otherClass} `}
        autocomplete="off"
      />
      {/* {textLimit && (
        <span className="text-xs text-gray-500">
          {value.length}/{textLimit} characters
        </span>
      )} */}
      {error && helperText && (
        <div className="text-red-500 text-sm mt-1">{helperText}</div>
      )}
      {textLimit < value.toString().length && (
        <div className="text-red-500 text-sm mt-1 inline">must be {textLimit} only</div>
      )}
    </div>
  );
};

export default CustomTextInput;
